import { HttpClient } from '@angular/common/http';
import { Routes } from '@angular/router';
import { LocalizeRouterSettings } from '@gilsdav/ngx-translate-router';
import { LocalizeRouterHttpLoader } from '@gilsdav/ngx-translate-router-http-loader';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';


export function appBaseHrefFactory(): string {
  return '/lfe-cap/';
}


export function HttpLoaderFactory(translate: TranslateService, location: Location, settings: LocalizeRouterSettings, http: HttpClient) {

  return new LocalizeRouterHttpLoader(translate, location, settings, http, '/lfe/public/i18n/locales.json');
}

export const routes: Routes = [

  {
    path: 'home-standalone',
    loadComponent: () => import('./standalone/home/home.component').then(h => h.HomeStandaloneComponent),
    // canActivate: [
    //   AuthGuard
    // ],
  },
  {
    path: 'home-modular',
    loadChildren: () => import('./modular/home/home.module').then(m => m.HomeModuleModule)
  },

  {
    path: 'login',
    loadChildren: () => import('./views/sign-in/SignInModule').then(m => m.SignInModule),
  },
  {
    path: 'new-login',
    loadChildren: () => import('./views/sign-in/SignInModule').then(m => m.SignInModule),
  },
  {
    path: 'update-password',
    loadChildren: () => import('./views/password-update/PasswordUpdateModule').then(m => m.PasswordUpdateModule),
  },
  {
      path: 'forgot-password',
      loadChildren: () => import('./views/password-reset/PasswordResetModule').then(m => m.PasswordResetModule),

  },
  {
    path: 'forgot-username',
    loadChildren: () => import('./views/username-recovery/UsernameRecoveryModule').then(m => m.UsernameRecoveryModule)
  },
  {
    path: 'en',
    redirectTo: ''
  },
  {
    path: 'fr',
    redirectTo: ''
  },
  {
    path: '',
    redirectTo: '/login', pathMatch:'full'
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
